import { useState } from 'react';
import apiClient from '../../services/apiClientService';
import { Routes } from '../../routes/RouteConstants';
import useErrorHandler from '../../hooks/useErrorHandler';
import { useTenant } from '../../contexts/TenantContext';

// The guest's own marketing switch. `setConsent` answers whether the change was saved.
const useMarketingConsent = () => {
  const { tenantId } = useTenant();
  const [loading, setLoading] = useState(false);
  const { handleError } = useErrorHandler();

  const setConsent = async (consented) => {
    setLoading(true);

    try {
      const url = `/v1/tenants/${tenantId}/users/me/marketing-consent`;
      await (consented ? apiClient.put(url) : apiClient.delete(url));
      return true;
    } catch (error) {
      handleError(error, Routes.PROFILE);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { setConsent, loading };
};

export default useMarketingConsent;
